import getAxiosInstance from "../../common/mhiAxios";
import { EditCaptionInfo } from "../../models/video";
import { LANGUAGE_JP } from "../../utils/Contants";

export default {
    // 辞書情報取得
    getAllContextPhrase(language: string): Promise<any> {
        return getAxiosInstance()
            .get("/api/getContextPhrases", { params: { language: language } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // 辞書更新
    updateContextPhrase(language: string, phrases: string[]): Promise<string[]> {
        return getAxiosInstance()
            .post("/api/updateContextPhrases", { language: language, phrases: phrases })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ビデオSTT編集
    EditVideoCaption(caption: EditCaptionInfo): Promise<any> {
        return getAxiosInstance()
            .post("/api/updateTranscript", {
                captionId: caption.captionId,
                userId: caption.userId,
                beforeUpdateTranscript: caption.beforeUpdateTranscript,
                afterUpdateTranscript: caption.afterUpdateTranscript,
                languge: caption.language,
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ビデオSTT再実行
    RerunSTT(videoId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/rerunSTT", { videoId: videoId, language: LANGUAGE_JP })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ビデオ処理情報取得
    getProcessStatus(userId: number): Promise<any> {
        return getAxiosInstance()
            .get("/api/getProcessingVideoList", { params: { userId: userId } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ビデオ処理情報取得（定期）
    getProcessStatusRepeat(userId: number): Promise<any> {
        return getAxiosInstance()
            .get("/api/getProcessingVideoList", { params: { userId: userId } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // ビデオSTT公開ステータス更新
    UpdateCaptionPublicState(
        userId: number,
        videoId: number,
        publicCaption: boolean,
        muteState: boolean
    ): Promise<any> {
        return getAxiosInstance()
            .post("/api/updateCaptionPublicState", {
                userId: userId,
                videoId: Number(videoId),
                videoSettings: [
                    { setting: "publiccaption", value: publicCaption },
                    { setting: "mute_audio", value: muteState },
                ],
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
};
